
// import { useParams } from "react-router-dom";
// import {  useLoteXID, useModalImgStore } from "../../../hooks";
// import { CargandoMedio, TablaInfoLote } from "../../components";


// export const InfomacionLote = () => {
//     const { id } = useParams();
//     const { loteXIDQuery } = useLoteXID(`${id}`);
//     const { openModalDistribucion } = useModalImgStore();
//     const abrirModalDistri = () => {
//         openModalDistribucion();
//     }
//     return (
//         <DisenioLote titulo="Información Lote" url={1}>

//             {(loteXIDQuery.isLoading)
//             ?   <CargandoMedio titulo="Cargando información de lote..." />
//             :   <TablaInfoLote data={loteXIDQuery?.data} />
//             }

//             {/* <Grid item sm={5} md={4} mt={5} >
//                 <Button variant='contained' fullWidth type='submit'
//                         onClick={ abrirModalDistri }
//                 >
//                     Distribuir Pollos
//                 </Button>
//             </Grid>
//             <ModalDistriPollos /> */}
//         </DisenioLote>
//     )
// }



import React, { useState } from 'react';
import { DisenioLote } from "../../layout";

import { Box, Card, CardContent, Grid, IconButton, Typography, Chip, Paper } from '@mui/material';
import { ChevronLeft, CalendarToday, TrendingUp, TrendingDown, TrendingFlat, Groups, 
    CheckCircle, BarChart, WarningAmber, ExpandMore, ExpandLess } from '@mui/icons-material';
import { iconos } from '../../../data';
import { useTheme } from '@emotion/react';







export const InfomacionLote = () => {


    const theme = useTheme();
    const [expandedCards, setExpandedCards] = useState({});


    const loteData = {
        id: '5610',
        tipo: 'Mixto',
        fechaInicio: '2024-01-15',
        diasActivos: 85,
        poblacionInicial: 1000,
        poblacionActual: 920,
        mortalidadTotal: { hembras: 45, machos: 35 },
        ventasTotal: { hembras: 28, machos: 17 },
        pesoPromedio: { hembras: 2.6, machos: 3.1 },
        consumoAlimento: {
        iniciador: { cantidad: 850, porcentaje: 30 },
        crecimiento: { cantidad: 1420, porcentaje: 50 },
        finalizador: { cantidad: 570, porcentaje: 20 }
        },
        conversionAlimenticia: 1.85,
        ingresosBrutos: 85400,
        costosTotales: 65200,
        utilidadNeta: 20200
    };



    const metricas = [
        {
        id: 'poblacion',
        titulo: "Pollos Totales",
        valor: loteData.poblacionActual,
        icono: 'sexo',
        color: "bg-blue-500",
        cambio: "+2.1%",
        tendencia: "up",
        detalles: [
            { label: "Hembras", valor: Math.round(loteData.poblacionActual * 0.52), color: "text-pink-600" },
            { label: "Machos", valor: Math.round(loteData.poblacionActual * 0.48), color: "text-blue-600" },
            { label: "Densidad", valor: "18.4 aves/m²", color: "text-gray-600" }
        ]
        },
        {
        id: 'mortalidad',
        titulo: "Mortalidad Total",
        valor: loteData.mortalidadTotal.hembras + loteData.mortalidadTotal.machos,
        icono: 'sexo',
        color: "bg-red-500",
        cambio: "+0.8%",
        tendencia: "up",
        detalles: [
            { label: "Hembras", valor: loteData.mortalidadTotal.hembras, color: "text-pink-600" },
            { label: "Machos", valor: loteData.mortalidadTotal.machos, color: "text-blue-600" },
            { label: "Tasa (%)", valor: "8.0%", color: "text-red-600" }
        ]
        },
        {
        id: 'ventas',
        titulo: "Ventas Realizadas",
        valor: loteData.ventasTotal.hembras + loteData.ventasTotal.machos,
        icono: 'sexo',
        color: "bg-green-500",
        cambio: "+15.2%",
        tendencia: "up",
        detalles: [
            { label: "Hembras", valor: loteData.ventasTotal.hembras, color: "text-pink-600" },
            { label: "Machos", valor: loteData.ventasTotal.machos, color: "text-blue-600" },
            { label: "Precio Prom.", valor: "$12,500/kg", color: "text-green-600" }
        ]
        },
        {
        id: 'peso',
        titulo: "Peso Promedio",
        valor: ((loteData.pesoPromedio.hembras + loteData.pesoPromedio.machos) / 2).toFixed(1),
        unidad: "kg",
        icono: 'sexo',
        color: "bg-purple-500",
        cambio: "+0.3kg",
        tendencia: "up",
        detalles: [
            { label: "Hembras", valor: `${loteData.pesoPromedio.hembras} kg`, color: "text-pink-600" },
            { label: "Machos", valor: `${loteData.pesoPromedio.machos} kg`, color: "text-blue-600" },
            { label: "Uniformidad", valor: "87%", color: "text-purple-600" }
        ]
        },
        {
        id: 'consumo',
        titulo: "Consumo de Alimento",
        valor: Object.values(loteData.consumoAlimento).reduce((acc, curr) => acc + curr.cantidad, 0),
        unidad: "kg",
        icono: 'sexo',
        color: "bg-orange-500",
        cambio: "-2.5%",
        tendencia: "down",
        detalles: [
            { label: "Iniciador", valor: `${loteData.consumoAlimento.iniciador.cantidad} kg (${loteData.consumoAlimento.iniciador.porcentaje}%)`, color: "text-yellow-600" },
            { label: "Crecimiento", valor: `${loteData.consumoAlimento.crecimiento.cantidad} kg (${loteData.consumoAlimento.crecimiento.porcentaje}%)`, color: "text-orange-600" },
            { label: "Finalizador", valor: `${loteData.consumoAlimento.finalizador.cantidad} kg (${loteData.consumoAlimento.finalizador.porcentaje}%)`, color: "text-red-600" }
        ]
        },
        {
        id: 'conversion',
        titulo: "Conversión Alimenticia",
        valor: loteData.conversionAlimenticia,
        unidad: "kg/kg",
        icono: 'sexo',
        color: "bg-teal-500",
        cambio: "Óptimo",
        tendencia: "neutral",
        detalles: [
            { label: "Semana 1-4", valor: "1.45", color: "text-green-600" },
            { label: "Semana 5-8", valor: "1.85", color: "text-yellow-600" },
            { label: "Semana 9-12", valor: "2.15", color: "text-orange-600" }
        ]
        }
    ];

    const toggleExpand = (cardId) => {
        setExpandedCards(prev => ({
        ...prev,
        [cardId]: !prev[cardId]
        }));
    };

    const formatNumber = (num) =>
        new Intl.NumberFormat('es-CO').format(num);

    const getTrendIcon = (tendencia) => {
        if (tendencia === 'up') return <TrendingUp fontSize="small" sx={{ color: 'green' }} />;
        if (tendencia === 'down') return <TrendingDown fontSize="small" sx={{ color: 'red' }} />;
        return <TrendingFlat fontSize="small" sx={{ color: 'gray' }} />;
    };

    return (
        <DisenioLote titulo="Información Lote" url={1}>
            <Box sx={{mt:2, height:'100%'}}>
                <Box mb={4}>
                <Card elevation={2}>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={3}>
                                <Box display="flex" gap={1} alignItems="center">
                                    {React.cloneElement(iconos['calendario'], 
                                        {style:{fontSize:20, color: theme.palette.primary.main} })
                                    }
                                    <Box sx={{display:'flex', flexDirection:'column', alignItems:'start'}}>
                                        <Typography variant="caption" sx={{fontWeight:'bold'}}>Inicio</Typography>
                                        <Typography variant="body2">
                                            {new Date(loteData.fechaInicio).toLocaleDateString('es-CO')}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid> 
                            <Grid item xs={6} md={3}>
                                <Box display="flex" gap={1} alignItems="center">
                                    {React.cloneElement(iconos['indicador'], 
                                        {style:{fontSize:22, color: theme.palette.secondary.main} })
                                    }
                                    <Box sx={{display:'flex', flexDirection:'column', alignItems:'start'}}>
                                        <Typography variant="caption" sx={{fontWeight:'bold'}}>Días</Typography>
                                        <Typography variant="body2">{loteData.diasActivos}</Typography>
                                    </Box>
                                </Box>
                            </Grid> 
                            <Grid item xs={6} md={3}>
                                <Box display="flex" gap={1} alignItems="center">
                                    {React.cloneElement(iconos['sexo'], 
                                        {style:{fontSize:22, color: theme.palette.primary.main} })
                                    }
                                <Box sx={{display:'flex', flexDirection:'column', alignItems:'start'}}>
                                    <Typography variant="caption" sx={{fontWeight:'bold'}}>Inicial</Typography>
                                    <Typography variant="body2">{formatNumber(loteData.poblacionInicial)}</Typography>
                                </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <Box display="flex" gap={1} alignItems="center">
                                    {React.cloneElement(iconos['terminada'], 
                                        {style:{fontSize:22, color:'green'} })
                                    }
                                <Box sx={{display:'flex', flexDirection:'column', alignItems:'start'}}>
                                    <Typography variant="caption" sx={{fontWeight:'bold'}}>Estado</Typography>
                                    <Typography variant="body2" color="success.main">Activo</Typography>
                                </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>

            {/* Métricas */}
            <Grid container spacing={2} sx={{mb:4, display:'flex', alignItems:'stretch'}}>
                {metricas.map((metrica) => (
                <Grid item xs={12} md={6} lg={4} key={metrica.id}>
                    <Card elevation={2} sx={{ transition:'0.3s', '&:hover':{boxShadow:4}, position:'relative' }}>
                        <CardContent>
                            <Box sx={{display:'flex', alignItems:'center', gap:2 }}>
                                <Box sx={{ p:1, borderRadius:1 }}>
                                    {React.cloneElement(iconos[metrica.icono], 
                                        {style:{fontSize:45, color:theme.palette.primary.main} })
                                    }
                                </Box>
                                <Box sx={{display:'flex', flexDirection:'column', justifyContent:'center', textAlign:'center'}}>
                                    <Typography variant="body2" sx={{fontWeight:'bold', fontSize:14}}>
                                        {metrica.titulo}
                                    </Typography>
                                    <Box sx={{display:"flex", textAlign:'center'}}>
                                        <Typography variant="h3" sx={{textAlign:'center', fontWeight:'500'}}>
                                            {formatNumber(metrica.valor)} {metrica.unidad}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={{position:'absolute', top:4, right:4}}>
                                    <IconButton size="small" onClick={() => toggleExpand(metrica.id)}
                                        sx={{border:'1px solid', borderColor:'primary.main', p:0.2}}
                                    >
                                        {expandedCards[metrica.id] ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                                    </IconButton>
                                </Box>
                            </Box>
                            {expandedCards[metrica.id] && (
                            <Box mt={2} borderTop="1px solid #eee" pt={1}>
                                {metrica.detalles.map((detalle, idx) => (
                                <Box
                                    key={idx}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    py={0.5}
                                >
                                    <Typography variant="caption" color="text.secondary">{detalle.label}</Typography>
                                    <Typography variant="caption" fontWeight="500" color={detalle.color}>{detalle.valor}</Typography>
                                </Box>
                                ))}
                            </Box>
                            )}
                        </CardContent>
                    </Card>
                </Grid>
                ))}
            </Grid>

            {/* Panel Financiero */}
            <Card elevation={2} sx={{mb:4}}>
                <CardContent>
                    <Box display="flex" gap={1} mb={2} alignItems="center">
                        { iconos['chart'] }
                        <Typography variant="h6">Financiero</Typography>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <Paper sx={{ p: 2, bgcolor: 'green.50' }}>
                                <Typography variant="caption">Ingresos Brutos</Typography>
                                <Typography variant="h6" color="green">
                                ${formatNumber(loteData.ingresosBrutos)}
                                </Typography>
                                <Typography variant="caption" color="green">+12.5% vs mes anterior</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={4}>
                        <Paper sx={{ p: 2, bgcolor: 'red.50' }}>
                            <Typography variant="caption">Costos Totales</Typography>
                            <Typography variant="h6" color="red">
                            ${formatNumber(loteData.costosTotales)}
                            </Typography>
                            <Typography variant="caption" color="red">+8.2% vs mes anterior</Typography>
                        </Paper>
                        </Grid>
                        <Grid item xs={12} md={4}>
                        <Paper sx={{ p: 2, bgcolor: 'blue.50' }}>
                            <Typography variant="caption">Utilidad Neta</Typography>
                            <Typography variant="h6" color="blue">
                                ${formatNumber(loteData.utilidadNeta)}
                            </Typography>
                            <Typography variant="caption" color="blue">
                                Margen: {((loteData.utilidadNeta / loteData.ingresosBrutos) * 100).toFixed(1)}%
                            </Typography>
                        </Paper>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* Alertas */}
            <Card variant="outlined">
                <CardContent>
                <Box display="flex" gap={1} alignItems="center" mb={2}>
                    <WarningAmber fontSize="small" color="warning" />
                    <Typography variant="h6">Alertas</Typography>
                </Box>

                <Box display="flex" flexDirection="column" gap={1}>
                    <Paper sx={{ p: 1, display: 'flex', gap: 1, bgcolor: 'green.50' }}>
                    <CheckCircle fontSize="small" color="success" />
                    <Typography variant="body2">
                        <strong style={{ color: '#166534' }}>Conversión óptima:</strong> 1.85 kg/kg dentro del rango ideal
                    </Typography>
                    </Paper>
                    <Paper sx={{ p: 1, display: 'flex', gap: 1, bgcolor: 'yellow.50' }}>
                    <WarningAmber fontSize="small" color="warning" />
                    <Typography variant="body2">
                        <strong style={{ color: '#92400e' }}>Mortalidad en aumento:</strong> +0.8% últimos 7 días - revisar ambiente
                    </Typography>
                    </Paper>
                </Box>
                </CardContent>
            </Card>
            </Box>




        </DisenioLote>
   
  );
};